var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreCrFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50065 2.66659C5.55513 2.66659 3.16732 5.0544 3.16732 7.99992C3.16732 10.9454 5.55513 13.3333 8.50065 13.3333C11.4462 13.3333 13.834 10.9454 13.834 7.99992C13.834 5.0544 11.4462 2.66659 8.50065 2.66659ZM1.83398 7.99992C1.83398 4.31802 4.81875 1.33325 8.50065 1.33325C12.1825 1.33325 15.1673 4.31802 15.1673 7.99992C15.1673 11.6818 12.1825 14.6666 8.50065 14.6666C4.81875 14.6666 1.83398 11.6818 1.83398 7.99992Z",
    fill: "#7799A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 8.66659C6.20087 8.66659 6.49935 8.36811 6.49935 7.99992C6.49935 7.63173 6.20087 7.33325 5.83268 7.33325C5.46449 7.33325 5.16602 7.63173 5.16602 7.99992C5.16602 8.36811 5.46449 8.66659 5.83268 8.66659Z",
    fill: "#7799A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 7.99992C9.16602 8.36811 8.86754 8.66659 8.49935 8.66659C8.13116 8.66659 7.83268 8.36811 7.83268 7.99992C7.83268 7.63173 8.13116 7.33325 8.49935 7.33325C8.86754 7.33325 9.16602 7.63173 9.16602 7.99992Z",
    fill: "#7799A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8327 7.99992C11.8327 8.36811 11.5342 8.66659 11.166 8.66659C10.7978 8.66659 10.4993 8.36811 10.4993 7.99992C10.4993 7.63173 10.7978 7.33325 11.166 7.33325C11.5342 7.33325 11.8327 7.63173 11.8327 7.99992Z",
    fill: "#7799A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreCrFr);
export default __webpack_public_path__ + "static/media/more_cr_fr.9c4dff31067e1da6d6beb5b35afc27b9.svg";
export { ForwardRef as ReactComponent };